import React, { useContext } from 'react';
import { CustomDrawer, CustomModal, DataList, DrawerContext } from 'commons-ui';

import useSettingsActions from '../../../useSettingsActions';
import { LIST_ENTITY_NAMES } from '../../../../../settingsV2Constant';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';
import { DEFAULT_CONFIG } from './helper';

const UserList: React.FC<{}> = () => {
	const { getUsersData, forceUpdate, setForceUpdate, turnForceUpdateOff } = useService();
	const { drawerConfig, setDrawerConfig } = useContext(DrawerContext);
	const { getActionHandler, getActionList } = useSettingsActions(makeActionHandler, makeActionList, {
		setForceUpdate
	});
	const actions = getActionList();
	return (
		<>
			<DataList
				defaults={DEFAULT_CONFIG}
				fetchData={getUsersData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				globalForceUpdate={forceUpdate}
				turnGlobalForceUpdateOff={turnForceUpdateOff}
				entity={LIST_ENTITY_NAMES.USERS}
			/>
			<CustomDrawer drawerConfig={drawerConfig} setDrawerConfig={setDrawerConfig} />
			<CustomModal />
		</>
	);
};

export default UserList;
